
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface OrganizationsHeaderProps {
  onCreateClick: () => void;
}

export function OrganizationsHeader({ onCreateClick }: OrganizationsHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Organizações</h2>
        <p className="text-muted-foreground">
          Gerencie as organizações da sua subscrição
        </p>
      </div>
      <Button onClick={onCreateClick} className="flex items-center gap-2">
        <Plus className="h-4 w-4" />
        Nova Organização
      </Button>
    </div>
  );
}
